import React from 'react';
import { makeConnect } from '../../infrastructure/components/mobx-extensions';
import { AccountAdminVM } from './account-admin.viewmodel';

const AccountAdminContext = React.createContext<AccountAdminVM>(null);
const connectAccountAdminVM = makeConnect(AccountAdminContext);

export { AccountAdminContext, connectAccountAdminVM };
